/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRulePublish extends models.BillingRule {
    constructor() {
        super();
        this.setDiscriminator("BillingRulePublish");
    }

    getFixupPrototypeFunction() { return BillingRulePublish.fixupPrototype; }

    static newInstance(model: Partial<BillingRulePublish>): BillingRulePublish {
        let obj = Object.assign(new BillingRulePublish(), model);
        BillingRulePublish.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRulePublish>): BillingRulePublish {
        if (!model) return null;
        return BillingRulePublish.newInstance(<BillingRulePublish> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRulePublish) {
        if (!obj) return;

        models.BillingRulePublish.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRulePublish): boolean {
        if (models.BillingRule.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRulePublish.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of master account ids to publish the scoped line items to.
     */
    master_account_ids: Array<string>;

}
